import { Component } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { camelCaseToDisplayString } from "src/services/utils/string.utils";
import { BaseSelectFormFieldComponent } from "../base-select-form.field.component";

@Component({
  selector: "rc-multi-select-form-field",
  templateUrl: "../base-select-form-field.component.html",
  styleUrls: ["./multi-select-form-field.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: MultiSelectFormFieldComponent,
    },
  ],
  standalone: false,
})
export class MultiSelectFormFieldComponent extends BaseSelectFormFieldComponent<string[]> {
  public constructor() {
    super(true);
  }

  protected toDisplayValue(input: string[]): string {
    if (!Array.isArray(input)) {
      return "";
    }

    return input.map(camelCaseToDisplayString).join(", ");
  }

  public readonly camelCaseToDisplayString = camelCaseToDisplayString;
}
